    import { useEffect, useRef, useState } from 'react';
    import './CollebrationRequest.css';
    import ReactLoading from 'react-loading';
    import { toast } from 'react-toastify';
    import { usePost } from '../../../hooks/usePost';
    import Layout from '../../../Components/Layout/Layout';
    import { useBEARER } from '../../../hooks/auth/useBEARER';
    import config from '../../../config';
    import api from '../../../hooks/api';

    function CollebrationRequest() {

        const [page, setPage] = useState(1);
        const [url, setUrl] = useState(null);
        const [Dataset, setDataset] = useState([]);

        const sentinelRef = useRef();
        const [endPage, setEndPage] = useState(false);

        const { userId } = useBEARER()

        const { data, loaded } = usePost(url, { user_id: userId, rowCount: 10 })


        useEffect(() => {
            if (page === 0) {
                setPage(1)
            }
            setUrl(`collebration/list/user?page=${page}`);
        }, [page])



        useEffect(() => {
            if (data) {
                if (page === 1) {
                    setDataset([])
                }
                setDataset((prev) => [...prev, ...data.data.data]);
                const observer = new IntersectionObserver((entries) => {
                    if (entries[0].isIntersecting) {
                        if (page < data.data.last_page) {
                            setPage(page + 1);
                        } else {
                            setEndPage(true)
                        }
                    }
                }, {
                    root: null,
                    rootMargin: "0px",
                    threshold: "1.0",
                })
                const sentinelNode = sentinelRef.current
                if (sentinelNode) {
                    observer.observe(sentinelNode)
                }

                return () => {
                    if (sentinelNode) {
                        observer.unobserve(sentinelNode)
                    }
                }
            }

        }, [data]);

        const fn_confirm = (id) => {

            const form = {
                collebration_id: id,
            }

            api.post(`collebration/accept/invite`, form, { headers: { "Content-Type": "multipart/form-data" } })
                .then((response) => {
                    if (response.data.success) {
                        toast.success(response.data.message, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            rtl: "true"
                        });
                        setPage(0)
                    } else {
                        toast.error(response.data.message, {
                            position: "top-left",
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            rtl: "true"
                        });
                    }
                });

        }
//بررسی شود نباید در معادلات مینی آپ باشد
        const fn_delete = (id) => {

            const form = {
                user_id: userId,
                collebration_id: id,
            }

            api.post(`collebration/destroy/byUser`, form, { headers: { "Content-Type": "multipart/form-data" } })
                .then((response) => {
                    if (response.data.success) {
                        toast.success(response.data.message, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            rtl: "true"
                        });
                        setPage(0)
                    } else {
                        toast.error(response.data.message, {
                            position: "top-left",
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            rtl: "true"
                        });
                    }
                });

        }

        return (
            <Layout>
                <div className='collebration'>

                    <div className='collebration-list'>
                        {Dataset && Dataset.map(item => {
                            return (<div className='collebration-list-item'>
                                <div className='item-field'>
                                    <span>نام فروشگاه : </span><span>{item.business_title}</span>
                                </div>
                                <div className='item-field'>
                                    <span>صفحه اینستاگرام : </span><span>{item.instagram_userName}</span>
                                </div>
                                <div className='item-field'>
                                    <span>موبایل : </span>
                                    <span>{item.collebrate_mobile}</span>
                                </div>
                                <div className='item-field'>
                                    <span>سمت همکار : </span><span>{(item.position??"").substring(0, 100)}</span>
                                </div>
                                <div className='item-field'>
                                    <span>پیام : </span><span>{item.message.substring(0, 70)}</span>
                                </div>
                                {!item.confirmed_role_at &&
                                    <>
                                        <div className="btn-send" request_id={item.id} onClick={(e) => {
                                            fn_confirm(parseInt(e.target.getAttribute("request_id")));
                                        }}>
                                            قبول همکاری
                                        </div>
                                        <div className="close" >
                                            <img src={process.env.PUBLIC_URL + '/images/close.png'} request_id={item.id} onClick={(e) => {
                                                fn_delete(parseInt(e.target.getAttribute("request_id")));
                                            }} />
                                        </div>
                                    </>
                                }
                                {item.confirmed_role_at &&
                                    <>
                                        <div className="btn-send confirm" request_id={item.id}>
                                            تایید شده
                                        </div>
                                    </>
                                }

                            </div>
                            )
                        })}
                        <div id="loading_page" ref={sentinelRef}>
                            {!endPage && <ReactLoading type={"bubbles"} color={"#296c83"} />}
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    export default CollebrationRequest;
